module.exports = "<span class=\"itemCount\" ng-if=\"$ctrl.hasValidBindings()\">{{$ctrl.renderFrontText()}}{{$ctrl.renderRange()}}{{$ctrl.renderEndText()}}</span>";


//////////////////
// WEBPACK FOOTER
// ./modules/shared/asRangeLabel/asRangeLabel.component.html
// module id = 689
// module chunks = 0